import { Timestamp } from "firebase/firestore";

export class CategoriaKOProntofibraDTO {
    id!: number;
    
   label!: string;
    
}

